<template>
  <div class="PartnerNew">
    <h2 class="subtitle">
      Création d'une nouvelle fiche entreprise...
      <button class="button is-transparent is-loading">...</button>
    </h2>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/partners";

export default {
  name: "PartnerNew",
  async mounted() {
    const partner = await this.$store.dispatch(t.ASK_NEW_PARTNER);
    setTimeout(() => {
      this.$router.push(`/partner/edit/${partner.uuid}`);
    });
  }
};
</script>

<style lang="scss">
.PartnerNew {
}
</style>
